import React from "react";
import touch from '../images/touch.gif'
import PleaseMessage from '../images/PleaseMessage.png'
import btnHome from '../images/btnHomeIcon.png'
import TextLoop from "react-text-loop";

const Main2 = () => {
  return (
    <div className="topicSection">

      {/* HOME BUTTON SECTION */}
      <div className="btnHomeSection bounce-in-fwd10">
        <button type="button" className="btnCircle">
          <img src={btnHome} alt="Date" height="50" width="50" /><br />
               HOME
            </button>
      </div>


      <div className="headerSub">
        <div className="headerSubTitle TextBig tracking-in-contract">
          <p>
            <TextLoop springConfig={{ stiffness: 140, damping: 8 }}>
              <span>TOUCH TO BEGIN</span>
              <span>觸摸開始</span>
              <span>SENTUH UNTUK MEMULAKAN</span>
              <span>தொடங்க தொடவும்</span>
            </TextLoop> 
          </p>
        </div>
      </div>

      <div className="headerName">
        <div className="headerTitle">
          {/* <h1>
            <div className="iconWard"></div>
            WARD VISIT
            </h1> */}
        </div>
      </div>


      {/* MAIN CONTENT SECTION */}
      <div className="contentPage"> 

        {/* ICON BOX */}
        <div className="iconSectionCenter iconSectionCenterPos iconCenter flip-in-hor-top2">
          <img src={touch} alt="Touch screen" height="600" width="600" />
        </div>


        {/* SCROLLING MESSEGE */}
        <div className="scrollingSection slide-in-bottom3">
          <marquee behavior="scroll" direction="left">Here is some scrolling text... right to left!</marquee>
        </div>


      </div>

    </div>
  );
};

export default Main2;